import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import {
  successImportItem,
  failedImportItem,
  ignoredImportItem,
  clearImportItems
} from '../../../actions/components/import-items-result';

const initialState = {
  items: []
};

const successImportItemHandler = reduxAction => ({
  [reduxAction.toString()]: (state, { payload: { counter, action, item } }) =>
    set(
      'items',
      [...state.items, { counter, action, name: item.name, status: 1 }],
      state
    )
});

const ignoreImportItemHandler = reduxAction => ({
  [reduxAction.toString()]: (state, { payload: { counter, action, item } }) =>
    set(
      'items',
      [...state.items, { counter, action, name: item.name, status: 1 }],
      state
    )
});

const failedImportItemHandler = reduxAction => ({
  [reduxAction.toString()]: (
    state,
    { payload: { counter, action, item, error } }
  ) =>
    set(
      'items',
      [...state.items, { counter, action, name: item.name, error, status: 0 }],
      state
    )
});

const clearItemsImportHandler = reduxAction => ({
  [reduxAction.toString()]: set('items', [])
});

export default createReducer(initialState, {
  ...successImportItemHandler(successImportItem),
  ...failedImportItemHandler(failedImportItem),
  ...ignoreImportItemHandler(ignoredImportItem),
  ...clearItemsImportHandler(clearImportItems)
});
